import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[appMobileValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: MobileValidatorDirective,
    multi: true
  }]
})
export class MobileValidatorDirective {

  constructor() { }
  validate(control : AbstractControl){
    if (control.value){
    if(control.value.indexOf("+234")== -1){
      return {inv:true} 
    }
    else{
      if(control.value.length < 11){
        return {lengthError:true}
      }
      return null;
      
    }
  }
  }

}
